<template>
  <v-divider v-if="!props.alone"></v-divider>
  <v-row no-gutters class="pt-2" :class="{ 'pr-4': props.alone }">
    <v-col cols="12">
      <ZLocationInput
        :latitude="props.coordinates.latitude"
        :longitude="props.coordinates.longitude"
        :type="coordinateUnits.toUpperCase() as AvaliableTypesType">
        <v-row>
          <v-col>
            <ZLatitudeField>
              <template #default="{ value, label }">
                <span>
                  <template v-if="value !== undefined">
                    {{ label }}:
                    <strong>{{ Number(value).toFixed(4) }}</strong>
                  </template>
                </span>
              </template>
            </ZLatitudeField>
          </v-col>
          <v-col v-if="coordinateUnits !== 'MGRS'">
            <ZLongitudeField>
              <template #default="{ value, label }">
                <span>
                  <template v-if="value !== undefined">
                    {{ label }}:
                    <strong>{{ Number(value).toFixed(4) }}</strong>
                  </template>
                </span>
              </template>
            </ZLongitudeField>
          </v-col>
        </v-row>
      </ZLocationInput>
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'

import { storeToRefs } from 'pinia'

import type { Coordinates } from '@tsyl/karonte/lib/types/coordinates'
import type { AvaliableTypesType } from '@tsyl/zapan2/lib/types/ZLocationInput'

import SettingsStore from '@/stores/settingsStore.ts'

const props = defineProps({
  coordinates: {
    type: Object as PropType<Coordinates>,
    required: true
  },
  alone: {
    type: Boolean,
    default: false
  }
})

const { coordinateUnits } = storeToRefs(SettingsStore())
</script>

<style lang="scss" scoped>
.border-top {
  border-top: 1px solid rgb(var(--v-theme-on-surface-variant));
}
</style>
